module.exports = __webpack_public_path__ + "Bliss2.39258710e16a0afe5340.woff2";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/Bliss2.woff2
// module id = ../../../../../src/assets/layout/fonts/Bliss2.woff2
// module chunks = styles